import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import ApiService from '../../services/apiService';
import Select from 'react-select';
import "./reports.css"
import { BarLoader } from 'react-spinners';
import moment from 'moment';
import { BsFiletypeCsv } from "react-icons/bs";
import { SiMicrosoftexcel } from "react-icons/si";
import { FaFileCircleExclamation } from "react-icons/fa6";
import { RiRefreshLine } from "react-icons/ri";
import Pagination from '../pagination/pagination';
import { toast } from 'react-toastify';
import { PiDownloadSimple } from "react-icons/pi";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useCurrency } from '../../Layouts/currencyContext';
import * as XLSX from "xlsx";
import Table from 'react-bootstrap/Table';
import { Fragment } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
const REPORT_URL = process.env.REACT_APP_REPORTS_URL;

const POAnalysis = () => {
    const apiService = new ApiService();
    const [rowData, setRowData] = useState([]);
    const [allData, setallData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [StockType, setStockType] = useState();
    const [SupplierList, setSuppliers] = useState();
    const { currencyPrecision } = useCurrency();
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [dateFilter, setdateFilter] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };
    const [formData, setFormData] = useState({
        fromDate: '',          // Today's date
        toDate: '',
        VendorName: [{ label: 'Select Supplier ', value: '0' }],
        Items: '',
    });
    const handleClearFilters = () => {
        const today = new Date();
        setFormData({
            fromDate: formatDate(today),
            toDate: formatDate(today),
            VendorName: [{ label: 'Select Supplier ', value: '0' }],
            Items: '',
        });
        setdateFilter(false)
    };
    useEffect(() => {
        const fetchDropdownData = async () => {
            try {
                const today = new Date();

                setFormData((prev) => ({
                    ...prev,
                    fromDate: formatDate(today),
                    toDate: formatDate(today),
                }));
                const params = new URLSearchParams();
                const suppliers = await apiService.get('GET_SUPPLIER');
                setSuppliers(suppliers?.data?.result);
            } catch (error) {
                console.error('Error fetching dropdown data:', error);
            }
        };
        fetchDropdownData();
        // getItems()
    }, []);

    const handlePrint = () => {
        {
            // dispatch(clearRows());
            const token = localStorage.getItem('Token');
            const DB = localStorage.getItem('DataBase');
            if (!token) {
                alert('Auth token is missing! Unable to proceed.');
                return;
            }
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open('', 'ReportPopup', `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`);

            if (popup) {
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = REPORT_URL;
                form.target = 'ReportPopup';

                const inputs = [
                    { name: 'authToken', value: token },
                    { name: '_db', value: DB },
                    { name: 'reportName', value: 'POAnalysis' },
                    { name: 'FromDate', value: formData?.fromDate },
                    { name: 'toDate', value: formData?.toDate },
                    { name: 'VendorNo', value: formData?.VendorName?.value?.supplier_ID || 'All' },
                    { name: 'PoNo', value: formData?.Items || 'All' },
                ];
                
                inputs.forEach(({ name, value }) => {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
            // navigate(`/Inventory/Purchase/Order/${selectedRow?.recordId}`, { state: selectedRow })
        }
    };
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleSupplierChange = async (selectedOption) => {
        setFormData({ ...formData, VendorName: selectedOption });
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value);
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }
    const handleDateFilterSelection = (e) => {
        setdateFilter(e);
    };
    const comparisonExportConfig = [
        { header: 'Supplier Name', key: 'vendorName', width: 25 },
        { header: 'Supplier ID', key: 'vendorId', width: 15 },
        { header: 'Requisition No', key: 'requisitionNo', width: 20 },
        { header: 'Requisition Date', key: 'requisitionDate', type: 'date', width: 18 },
        { header: 'Requestor', key: 'requestor', width: 20 },
        { header: 'POrder No', key: 'porderNo', width: 18 },
        { header: 'PO Date', key: 'poDate', type: 'date', width: 18 },
        { header: 'PO Amount', key: 'poAmount', type: 'amount', width: 15 },
        { header: 'GRN No', key: 'grnNo', width: 18 },
        { header: 'GRN Date', key: 'grnDate', type: 'date', width: 18 },
        { header: 'GRN Amount', key: 'grnAmount', type: 'amount', width: 15 },
        { header: 'Invoice No', key: 'invoiceRegNo', width: 18 },
        { header: 'Invoice Date', key: 'invoiceDate', type: 'date', width: 18 },
        { header: 'Invoice Amount', key: 'invAmount', type: 'amount', width: 15 },
        { header: 'Amount Paid', key: 'amountPaid', type: 'amount', width: 15 },
        { header: 'Balance', key: 'balance', type: 'amount', width: 15 },
    ];
    const formatExportValue = (value, type) => {
        if (value === null || value === undefined || value === 0) return '';

        if (type === 'date') {
            return moment(value).isValid()
                ? moment(value).format('DD-MMM-YYYY')
                : '';
        }

        if (type === 'amount') {
            return Number(value).toFixed(currencyPrecision?.exp1 || 3);
        }

        return value;
    };
    const exportComparisonCSV = () => {
        if (!rowData?.length) {
            toast.info('No data found to export');
            return;
        }

        const headers = comparisonExportConfig.map(c => c.header).join(',');

        const rows = rowData.map(item =>
            comparisonExportConfig
                .map(c => `"${formatExportValue(item[c.key], c.type)}"`)
                .join(',')
        );

        const csvContent = [headers, ...rows].join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'PO_Comparison.csv';
        link.click();

        toast.success('PO_Comparison.csv downloaded');
    };
    const exportComparisonExcel = () => {
        if (!rowData?.length) return;

        const excelData = rowData.map(item => {
            const row = {};
            comparisonExportConfig.forEach(col => {
                row[col.header] = formatExportValue(item[col.key], col.type);
            });
            return row;
        });

        const worksheet = XLSX.utils.json_to_sheet(excelData);

        // Column widths
        worksheet['!cols'] = comparisonExportConfig.map(col => ({
            wch: col.width,
        }));

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'PO Comparison');

        XLSX.writeFile(workbook, 'PO_Comparison.xlsx');
    };
    const groupedData = Object.values(
        rowData.reduce((acc, row) => {
            const key = [
                row.vendorName,
                row.vendorId,
                row.requisitionNo,
                row.requisitionDate,
                row.porderNo,
                row.poDate,
                row.poAmount
            ].join('|');

            if (!acc[key]) {
                acc[key] = {
                    supplier: `${row.vendorName} (${row.vendorId})`,
                    requisitionNo: row.requisitionNo,
                    requisitionDate: row.requisitionDate,
                    porderNo: row.porderNo,
                    poDate: row.poDate,
                    poAmount: row.poAmount,
                    grnNos: []
                };
            }

            if (row.grnNo) {
                acc[key].grnNos.push(row.grnNo);
            }

            return acc;
        }, {})
    );
    useState(() =>
        Object.fromEntries(Object.keys(groupedData).map(k => [k, true]))
    );
    return (
        <div className='p-4'>
            <div className='gridBg m-0 row' style={{ borderRadius: "16px 16px 16px 16px" }}>
                <div className='col-12'>
                    <div className='row'>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.VendorName}
                                onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                                isClearable
                                options={SupplierList?.map((sup) => ({ value: sup, label: sup?.supplierName }))}

                            />
                        </div>
                        <div className='col'>
                            <input
                                type='text'
                                className="form-Input w-100"
                                placeholder='PO No'
                                value={formData.Items}
                                name="Items"
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="d-flex justify-content-between start col">
                            <DatePicker
                                selected={formData.fromDate}
                                // disabled={!dateFilter}
                                onChange={(date) => handleDateChange({ name: 'fromDate', value: date })}
                                className="p-2 form-Input w-100"
                                dateFormat="dd-MM-yyyy"
                            />
                        </div>
                        <div className="d-flex justify-content-between start col">
                            <DatePicker
                                selected={formData.toDate}
                                onChange={(date) => handleDateChange({ name: 'toDate', value: date })}
                                className="p-2 form-Input w-100"
                                // disabled={!dateFilter}

                                dateFormat="dd-MM-yyyy"
                            />
                        </div>
                    </div>
                </div>
                <div className='col-5 gap-5 d-flex mt-2'>
                    <div onClick={() => handlePrint()} className='mainbtnGry w-50 mt-2 flex-end gap-2'>
                        <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Show</div>
                    </div>
                    <div onClick={() => handleClearFilters()} className='mainbtnRed w-50 flex-end mt-2 gap-2'>
                        <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Reset</div>
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-between p-2 gridBg mt-2' style={{ borderRadius: "8px 8px 0px 0px " }}>
                <div className='mainInvHead center' >Purchase Order Analysis</div>
            </div>
            <div className='gridshad'>
                {loading === true ?
                    <div className="center p-5">
                        <BarLoader color="#6E5199" height={3} width={200} />
                    </div>
                    :
                    <Table bordered hover responsive className="custom-table shadow-sm">
                        <thead className="table-header">
                            <tr>
                                <th className="text-center">Supplier</th>
                                <th >Requisition No</th>
                                <th>Requisition Date</th>
                                <th className="text-end">PO No</th>
                                <th>PO Date</th>
                                <th>PO Amount</th>
                                <th className="text-start">GRN No</th>
                            </tr>
                        </thead>

                        <tbody>
                            {groupedData.map((row, index) => (
                                <tr key={index}>
                                    <td className="fw-semibold supplier-cell">
                                        {row.supplier}
                                    </td>
                                    <td style={{ width: "150px" }}>{row.requisitionNo}</td>
                                    <td style={{ width: "170px" }}>{moment(row.requisitionDate).format("DD-MMM-YYYY")}</td>
                                    <td className="fw-semibold">{row.porderNo}</td>
                                    <td style={{ width: "150px" }}>{row.poDate}</td>
                                    <td className="amount-cell" style={{ width: "150px" }}>
                                        {row.poAmount?.toFixed(3)}
                                    </td>
                                    <td>
                                        <div className="grn-badges">
                                            {row.grnNos.length > 0
                                                ? row.grnNos.map((g, i) => (
                                                    <span key={i} className="grn-badge">{g}</span>
                                                ))
                                                : <span className="text-muted">—</span>}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                }
            </div>
        </div>
    );
};
export default POAnalysis;